import { createApp } from "vue";
import ElementPlus from "element-plus";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './permission';
import "element-plus/dist/index.css";
import "./assets/css/index.scss";
import "./assets/icons/index.js";



import { ComponentCustomProperties } from "vue";
import { Store } from "vuex";
declare module "@vue/runtime-core" {
  interface State {
    count: number;
  }

  interface ComponentCustomProperties {
    $store: Store<State>;
  }
}

createApp(App).use(store).use(router).use(ElementPlus).mount("#app");
// await router.isReady()
// const app = createApp(App)
// app.use(store).use(router).use(ElementPlus)
// await router.isReady()
// app.mount("#app")